import { useState } from "react";
import styled from "styled-components";

import typography from "../../theme/typography";

const StyleButton = styled.button`
  ${typography.buttonText2};
  background-color: ${(props) => props.theme.color.primary};
  color: ${(props) => props.theme.color.black};
  border: none;
  border-radius: 50%;
  cursor: pointer;
  width: 100px;
  height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    margin-top: 6px;
    width: 68px;
    height: 68px;
  }
  p {
    margin-top: 1px;
  }
`;

const PlaceHolder = styled.div`
  width: 68px;
  height: 68px;
`;

const ImageButton = ({ img, text, onClick }) => {
  const [loading, setLoading] = useState(true);
  return (
    <StyleButton onClick={onClick}>
      {loading && <PlaceHolder />}
      <img src={img} alt={text} onLoad={() => setLoading(false)} />
      <p>{text}</p>
    </StyleButton>
  );
};

export default ImageButton;
